import reducers from './reducers';

// Named exports for types, selectors, and operations
export { default as shoppingTypes } from './types';
export { default as shoppingSelectors } from './selectors';
export { default as shoppingOperations } from './operations';

// Default export is the reducers
export default reducers;
